var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"d-flex align-items-center description animate-cell"},[_c('div',{staticClass:"wrapper text-truncate description"},[_vm._v("\n    "+_vm._s(_vm.description)+"\n  ")])])}
var staticRenderFns = []

export { render, staticRenderFns }